import type { CombatState, DungeonFloor, GameMode, PlayerState } from '../game/types';

export const SAVE_VERSION = 3 as const;
export const SAVE_STORAGE_KEY = 'vo-tan-me-cung-save-v3';

export interface SaveSnapshot {
  version: typeof SAVE_VERSION;
  savedAt: number;
  player: PlayerState;
  dungeon: DungeonFloor;
  mode: GameMode;
  combat: CombatState | null;
  previousRoomId: string | null;
  lastMessage: string | null;
}

export interface SaveSnapshotInput {
  player: PlayerState;
  dungeon: DungeonFloor;
  mode: GameMode;
  combat: CombatState | null;
  previousRoomId: string | null;
  lastMessage: string | null;
}

export function createSaveSnapshot(input: SaveSnapshotInput): SaveSnapshot {
  return {
    version: SAVE_VERSION,
    savedAt: Date.now(),
    player: structuredClone(input.player),
    dungeon: structuredClone(input.dungeon),
    mode: structuredClone(input.mode),
    combat: structuredClone(input.combat),
    previousRoomId: input.previousRoomId,
    lastMessage: input.lastMessage,
  };
}

export function writeSaveToStorage(snapshot: SaveSnapshot): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(SAVE_STORAGE_KEY, JSON.stringify(snapshot));
  }
}

export function readSaveFromStorage(): SaveSnapshot | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  const raw = localStorage.getItem(SAVE_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const data = JSON.parse(raw) as SaveSnapshot;
    if (
      data.version !== SAVE_VERSION ||
      !data.player ||
      !data.dungeon ||
      !data.mode ||
      data.player.alive === false
    ) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearSaveFromStorage(): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(SAVE_STORAGE_KEY);
  }
}
